import React, { useState } from 'react'
import { Box, Fab } from '@mui/material'
import { Add } from '@mui/icons-material'
import MemberTable from './UserTable'
import AddUserDialog from './AddUserDialog'


const AllMembersPanel = () => {

  const [open, setOpen] = useState(false)

  return (
    <Box sx={{ pb: '100px' }}>
      <MemberTable />
      <Fab
        color='secondary'
        aria-label='add'
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          right: theme => theme.spacing(3),
          bottom: theme => theme.spacing(3),
        }}
      >
        <Add />
      </Fab>
      {open && <AddUserDialog onClose={() => setOpen(false)} />}
    </Box>
  )
}

export default AllMembersPanel
